import { ContentfulRenderer, Icon } from 'components';
import { Document } from '@contentful/rich-text-types';
import React from 'react';
import clsx from 'clsx';
import { TBlockIcon } from 'interfaces/IHxTraining';
import styles from './styles.module.scss';

type TBlockIconColor = 'dark' | 'light';

interface IHxTrainingBlockProps {
  title: string;
  description: Document;
  buttons?: React.ReactNode;
  customContent?: React.ReactNode;
  icon?: TBlockIcon;
  iconColor?: TBlockIconColor;
  compact?: boolean;
}

const HxTrainingBlock = ({
  title,
  description,
  buttons,
  customContent,
  icon,
  iconColor = 'light',
  compact = false,
}: IHxTrainingBlockProps) => {
  const iconClasses = clsx(styles.blockIcon, {
    [styles.light]: iconColor === 'light',
    [styles.dark]: iconColor === 'dark',
  });
  return (
    <div className={clsx(styles.block, { [styles.compact]: compact })}>
      {icon && (
        <div className={iconClasses}>
          <Icon iconType={icon} width={25} height={25} />
        </div>
      )}
      <div className={styles.blockContent}>
        <h2 className={clsx(styles.blockTitle, { [styles.compact]: compact })}>
          {title}
        </h2>
        <div className={styles.blockDescription}>
          <ContentfulRenderer>{description}</ContentfulRenderer>
        </div>
        {buttons && (
          <div
            className={clsx(styles.blockButtons, { [styles.compact]: compact })}
          >
            {buttons}
          </div>
        )}
        {customContent}
      </div>
    </div>
  );
};

export default HxTrainingBlock;
